import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { ReactComponent as IconEye } from "@assets/Icons/Icon_Eye.svg";
import { GenericTag } from "@ui-components/Tag/GenericTag";

export interface AlertItemHistory {
  id: number;
  alertName: string;
  severity: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  isActive: boolean;
  trigger: string;
  resourceName: string;
  tenantName: string;    
}
  
export function makeAlertColumns(
  handleView: (alert: AlertItemHistory) => void
): GenericTableColumn<AlertItemHistory>[] {
  return [
    {
      header: 'Details',
      accessor: 'alertName',
      renderCell: row => (
        <button
          className="px-3 py-1 border border-semantic-border-secondary rounded text-semantic-text-secondary hover:bg-semantic-state-active"
          onClick={() => handleView(row)}
        >
          <IconEye className="w-6 h-6" />
        </button>
      ),
    },
    { header: 'Alert Name', accessor: 'alertName' },
    { header: 'Service Name', accessor: 'resourceName' },
    { header: 'Customer Name', accessor: 'tenantName' },
    {
      header: 'Severity',
      accessor: 'severity',
      renderCell: row => {
        const status = row.severity;
        let variant: 'default' | 'neutral' | 'error' | 'warning';
        let label: string;

        switch (status) {
          case 'informational':
            variant = 'neutral'; label = 'Informational'; break;
          case 'alert':
            variant = 'neutral'; label = 'Alert'; break;
          case 'critical':
            variant = 'error'; label = 'Critical'; break;
          default:
            variant = 'warning'; label = status.charAt(0).toUpperCase() + status.slice(1);
        }

        return (
          <GenericTag
            variant={variant}
            label={label}
            size="small"
            rounded="full"
            className="w-24 justify-center text-center"
          />
        );
      },
    },
    {
      header: 'Created At',
      accessor: 'createdAt',
      renderCell: row =>
        new Date(row.createdAt).toLocaleDateString('en-US', { dateStyle: 'medium' }),
    },
    { header: 'Description', accessor: 'description' },
  ];
}

  
